import Button from "blocks.simple/button/button";
import translate from "core/translate";
import { changeLocation, routes } from "features/routes";
import React from "react";
import styles from "./displays__uploadLogNotification.jcss"

const DisplaysUploadLogNotification = () => {
    const goToUploadLogTasks = () => {
        changeLocation(routes.uploadLogTasks.path)
    }
    
    return (
        <div className={styles.wrapper}>
            <div className={styles.message}>
                {translate('uploadLogTaskCreated')}
            </div>
            <Button fullWidth={false} onClick={goToUploadLogTasks} rounded={"full_micro"}>
                {translate("go")}
            </Button>
        </div>
    )
};

export default DisplaysUploadLogNotification